const conditions = () => {
  return [{ projectType: { $ne: '' } }, { assetClass: { $in: ['object.asset-class.options.hotel', 'object.asset-class.options.healthcare-medical'] } }]
}

export default conditions
